import { render } from "./iap-input-number.vue?vue&type=template&id=c4cd6260&ts=true"
import script from "./iap-input-number.vue?vue&type=script&lang=ts"
export * from "./iap-input-number.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__